<template>
  <div class="navigation" :class="{ disabled: disabled }">
    <div class="inner-navigation" @click.capture="preventRoutingIfDisabled">
      <router-link :to="preferencesRoute" active-class="active">
        <span>{{ $tr('vacancy.preferences.title') }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
  import Navigation from '@/components/vacancy/Navigation.vue'

  export default {
    extends: Navigation
  }
</script>

<style lang="scss" scoped>
  @import '../../../../styles/components/vacancy/Navigation.scss';
</style>
